import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';
import { SchedulerService } from '../../services/scheduler.service';

@Component({
    selector: 'app-scheduler-header',
    imports: [CommonModule],
    templateUrl: './scheduler-header.component.html',
    styleUrl: './scheduler-header.component.css'
})
export class SchedulerHeaderComponent {

  @ViewChild('scrollableDiv') scrollableDiv!: ElementRef;
  signal$ = toObservable(this.s.scrollPosition).pipe(
    tap((value) => {
      if (this.scrollableDiv) {
        this.scrollableDiv.nativeElement.scrollLeft = value;
      }
    })
  );

  data: any;
  constructor(public s: SchedulerService) {
    this.data = this.s.getData();
    this.signal$.subscribe();
  }

}
